import { HttpClient } from '../HttpClient';
/**
 * @typedef {Object} CompanyPolicyConfig
 * @property {number} id - Unique identifier for the policy configuration.
 * @property {number} companyId - The company ID this policy belongs to (0 may represent global/default).
 * @property {string} nodeName - The policy node or category (e.g., 'companyPolicy', 'overtime', 'attendance').
 * @property {string} propertyName - The name of the specific policy or property.
 * @property {string} value - The value assigned to the property (may be boolean, number, or string as text).
 * @property {number} companyPolicyVersionId - The version ID of the company policy set this belongs to.
 */

/**
 * Fetches company policies for a given company ID.
 * @param {number} CompanyId - The ID of the company.
 * @returns {Promise<{ data: CompanyPolicyConfig[] }>} - Promise resolving to an object containing the data array.
 */

export const GetCompanyPolicies = async (CompanyId) => {
  try {
    /** @type {{ data: CompanyPolicyConfig[] }} */
    const { data } = await HttpClient.get(`api/companies/${CompanyId}/policies`);
    return await Promise.resolve({ data });
  } catch (err) {
    return Promise.reject(err);
  }
};
